export default __webpack_public_path__ + "static/media/D9C99ED9-05.958fa350.png";